export const CREATE_OR_EDIT_TAG_DIALOG_ID = 'createOrEditTagDialogId';
